export const API_BASE_URL = 'https://backend.recc.org.in/api';
export const BASE_URL = 'https://backend.recc.org.in';
export const razorpay_key = 'rzp_live_SmOnTzTXtrgvn0';
// export const razorpay_key = 'rzp_test_Rf5wtIGvhjhFUi';
